import mixitup from 'mixitup';
import { mergeOptions } from '../../helpers/common/merge-options';
import mixitupMultifilter from './lib/mixitup-multifilter.js';

export interface MixitupOptions {
	itemSelector: string;
	resetSelector: string;
	filterSelector: string;
	multifilter: boolean;
	animationDuration: number;
}

export class Mixit {
	static options: MixitupOptions = {
		itemSelector: '.js-mixitup-item',
		resetSelector: '.js-mixitup-filter',
		filterSelector: '.js-mixitup-filter',
		multifilter: true,
		animationDuration: 600,
	};
	protected options: MixitupOptions;
	private mixer;

	constructor(public element: HTMLElement, options?: Partial<MixitupOptions>) {
		this.options = mergeOptions(Mixit, options, element);
		mixitup.use(mixitupMultifilter);

		this.mixer = mixitup(element, {
			multifilter: {
				enable: this.options.multifilter,
			},
			selectors: {
				target: this.options.itemSelector,
				control: this.options.filterSelector,
			},
			animation: {
				effects: 'scale',
				applyPerspective: false,
				duration: this.options.animationDuration,
			},
			controls: {
				scope: 'local',
			},
			callbacks: {
				onMixStart: (state: any, futureState: any) => {
					this.element.dispatchEvent(new CustomEvent('mixStart', {
						detail: {
							state: state,
							futureState: futureState,
						},
					}));
				},
				onMixEnd: (state: any, futureState: any) => {
					this.element.dispatchEvent(new CustomEvent('mixEnd', {
						detail: {
							state: state,
							futureState: futureState,
						},
					}));
				},
			},
		});
	}

	public filter(filterString: string) {
		this.mixer.filter(filterString.length > 0 ? filterString : 'all');
	}

	public sort(sortString: string) {
		this.mixer.sort(sortString);
	}
}
